import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>9kInfoTech</h3>
            <p>
              Your trusted partner for innovative software solutions. 
              We transform ideas into powerful digital experiences.
            </p>
            <div className="social-links">
              <a href="#" className="social-link">📘</a>
              <a href="#" className="social-link">🐦</a>
              <a href="#" className="social-link">💼</a>
              <a href="#" className="social-link">📷</a>
            </div>
          </div>
          
          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Mobile App Development</a></li>
              <li><a href="#services">Web Development</a></li>
              <li><a href="#services">Software Development</a></li>
              <li><a href="#services">UI/UX Design</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Company</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
              <li><a href="#">About Us</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <ul className="contact-info">
              <li>📧 info@9kinfotech.com</li>
              <li>📱 +1 (555) 123-4567</li>
              <li>📍 123 Tech Street, Silicon Valley, CA 94025</li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; 2024 9kInfoTech. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
